<template>
  <div class="relative min-h-screen overflow-hidden bg-white">
    <div class="relative z-10 min-h-screen bg-transparent py-16 px-4">
      <!-- Main Container -->
      <div class="max-w-6xl mx-auto">
        <!-- Header Section with Decorative Elements -->
        <div class="relative flex items-center justify-center mb-16">
          <!-- Enhanced Left Decorative Curve -->
          <div
            class="absolute left-0 top-1/2 transform -translate-y-1/2 animate-float-left"
          >
            <div class="relative">
              <img
                src="../assets/images/shape (1).png"
                alt=""
                class="h-40 drop-shadow-lg"
              />
              <!-- Glow Effect -->
              <div
                class="absolute inset-0 bg-blue-400/20 blur-xl rounded-full animate-pulse"
              ></div>
            </div>
          </div>

          <!-- Enhanced Right Decorative Curve -->
          <div
            class="absolute right-0 top-1/2 transform -translate-y-1/2 animate-float-right"
          >
            <div class="relative">
              <img
                src="../assets/images/shape (1).png"
                alt=""
                class="h-40 drop-shadow-lg transform scale-x-[-1]"
              />
              <!-- Glow Effect -->
              <div
                class="absolute inset-0 bg-red-400/20 blur-xl rounded-full animate-pulse"
              ></div>
            </div>
          </div>

          <!-- Enhanced Main Content -->
          <div class="text-center max-w-3xl px-8 mt-10 relative">
            <!-- Background Glow -->
            <div
              class="absolute inset-0 bg-gradient-to-r from-teal-100/30 via-white/50 to-red-100/30 blur-3xl rounded-3xl animate-pulse-gentle"
            ></div>

            <div class="relative z-10">
              <h1
                class="text-3xl mt-8 md:text-4xl font-bold bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 bg-clip-text text-transparent mb-6 leading-tight animate-fade-in-up drop-shadow-sm text-style"
              >
                Empowering communities through
                <span
                  class="bg-blue-500 bg-clip-text text-transparent relative"
                >
                  Mshel Foundation
                </span>
              </h1>

              <!-- Enhanced Quote Section -->
              <div
                class="relative backdrop-blur-sm bg-white/60 rounded-2xl p-8 mb-8 border border-white/40 shadow-2xl animate-fade-in-up delay-300"
              >
                <!-- Decorative Quote Marks -->
                <div
                  class="absolute -top-6 -left-6 text-6xl text-blue-500 font-serif animate-bounce-gentle"
                >
                  "
                </div>
                <div
                  class="absolute -bottom-6 -right-6 text-6xl text-blue-500 font-serif animate-bounce-gentle"
                >
                  "
                </div>

                <p
                  class="text-gray-700 text-lg md:text-xl mb-4 leading-relaxed italic font-light"
                >
                  The foundation was born out of Dr. Barka Mshelia’s passion for
                  helping the needy and empowering young entrepreneurs through
                  mentorship and crucial financial support, <br />
                  enabling them to turn their innovative ideas into thriving
                  businesses.
                </p>
              </div>

              <!-- Enhanced Action Buttons -->
              <div
                class="flex justify-center gap-4 flex-wrap animate-fade-in-up delay-500"
              >
                <router-link to="/donate">
                  <button
                    class="group relative overflow-hidden bg-yellow text-white px-8 py-3 rounded-lg font-semibold transition-all duration-500 transform hover:scale-105 hover:-translate-y-1 shadow-xl"
                  >
                    <span class="relative z-10 flex items-center gap-2">
                      Donate Now
                      <span
                        class="group-hover:translate-x-1 transition-transform duration-300"
                        >→</span
                      >
                    </span>
                    <!-- Shimmer Effect -->
                    <div
                      class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"
                    ></div>
                    <!-- Glow Effect -->
                    <div
                      class="absolute inset-0 bg-teal-400/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl rounded-lg"
                    ></div>
                  </button>
                </router-link>

                <router-link to="/">
                <button
                  class="group relative overflow-hidden border-2 border-gray-400 hover:border-gray-500 text-gray-700 hover:text-gray-800 bg-white/80 hover:bg-white/90 backdrop-blur-sm px-8 py-3 rounded-lg font-semibold transition-all duration-500 transform hover:scale-105 hover:-translate-y-1 shadow-lg hover:shadow-xl"
                >
                  <span class="relative z-10 flex items-center gap-2">
                    <span class="text-xl group-hover:animate-bounce">📹</span>
                    Watch Video
                  </span>
                  <!-- Subtle Glow -->
                  <div
                    class="absolute inset-0 bg-gradient-to-r from-gray-100/50 to-gray-200/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-lg"
                  ></div>
                </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Images Gallery -->
      <heroSlider />
      <aboutFoundation />
    </div>
  </div>
</template>

<script>
import heroSlider from "../components/heroSlider.vue";
import aboutFoundation from "@/components/aboutFoundation.vue";

export default {
  name: "about-view",
  components: {
    heroSlider,
    aboutFoundation,
  },
  methods: {
    getParticleStyle() {
      const randomX = Math.random() * 100;
      const randomY = Math.random() * 100;
      const randomDelay = Math.random() * 8;
      const randomDuration = 8 + Math.random() * 6;

      return {
        left: `${randomX}%`,
        top: `${randomY}%`,
        animationDelay: `${randomDelay}s`,
        animationDuration: `${randomDuration}s`,
      };
    },
  },
};
</script>

<style scoped>
/* Custom Animations */
@keyframes float-slow {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(180deg);
  }
}

@keyframes pulse-slow {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.05);
  }
}

@keyframes bounce-gentle {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes drift {
  0% {
    transform: translateY(0px) translateX(0px);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100px) translateX(50px);
    opacity: 0;
  }
}

@keyframes float-left {
  0%,
  100% {
    transform: translateY(0px) translateX(0px);
  }
  50% {
    transform: translateY(-10px) translateX(5px);
  }
}

@keyframes float-right {
  0%,
  100% {
    transform: translateY(0px) translateX(0px);
  }
  50% {
    transform: translateY(-8px) translateX(-5px);
  }
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.text-style {
  font-family: Montserrat !important;
}

@keyframes expand-line {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

@keyframes pulse-gentle {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.5;
  }
}

/* Animation Classes */
.animate-float-slow {
  animation: float-slow 8s ease-in-out infinite;
}

.animate-pulse-slow {
  animation: pulse-slow 4s ease-in-out infinite;
}

.animate-bounce-gentle {
  animation: bounce-gentle 4s ease-in-out infinite;
}

.animate-drift {
  animation: drift 12s linear infinite;
}

.animate-float-left {
  animation: float-left 6s ease-in-out infinite;
}

.animate-float-right {
  animation: float-right 7s ease-in-out infinite;
}

.animate-fade-in-up {
  animation: fade-in-up 1s ease-out forwards;
  opacity: 0;
}

.animate-expand-line {
  animation: expand-line 1s ease-out forwards;
}

.animate-pulse-gentle {
  animation: pulse-gentle 6s ease-in-out infinite;
}

/* Delay Classes */
.delay-300 {
  animation-delay: 0.3s;
}
.delay-500 {
  animation-delay: 0.5s;
}
.delay-700 {
  animation-delay: 0.7s;
}
.delay-1000 {
  animation-delay: 1s;
}

/* Enhanced Glassmorphism */
.backdrop-blur-sm {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* Custom Hover Effects */
.group:hover .group-hover\:animate-bounce {
  animation: bounce 1s ease-in-out infinite;
}

/* Responsive Design */
@media (max-width: 768px) {
  .text-5xl {
    font-size: 2.5rem;
  }

  .text-6xl {
    font-size: 3rem;
  }

  .px-8 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (max-width: 640px) {
  .grid-cols-3 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .gap-4 {
    gap: 1rem;
  }

  .flex-wrap {
    flex-direction: column;
    align-items: center;
  }

  .absolute.left-0,
  .absolute.right-0 {
    display: none;
  }
}

/* Enhanced Drop Shadow */
.drop-shadow-lg {
  filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04))
    drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
}

.drop-shadow-sm {
  filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.05));
}

/* Smooth Transitions */
* {
  transition-property: transform, opacity, box-shadow;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
}
</style>
